import type { HttpGet, HttpRequest } from '@/shared/infra/http'
import type {
  FlywayRegion,
  MeasurementSystem,
  UserProfile,
  UserProfileResult,
} from '@/shared/domain'
import type { LoadUserProfile } from '@/modules/auth/use-cases'

type ApiUser = {
  id: string
  email: string
  firstName?: string
  lastName?: string
  displayName?: string
  phone?: string
  dateOfBirth?: string
  flywayRegion?: FlywayRegion
  addressLine1?: string
  addressLine2?: string
  city?: string
  state?: string
  zipCode?: string
  country?: string
  emergencyContact?: string
  emergencyPhone?: string
  emergencyRelationship?: string
  emergencyContact2?: string
  emergencyPhone2?: string
  emergencyRelationship2?: string
  vehicleMake?: string
  vehicleModel?: string
  vehicleColor?: string
  vehicleLicensePlate?: string
  vehicleState?: string
  emailVerifiedAt?: string
  phoneVerifiedAt?: string
  isStaff?: boolean
  onboardingStep?: number
  measurementSystem?: MeasurementSystem
}

type ApiResponse = {
  exists: boolean
  user: ApiUser
}

export class EdgeLoadUserProfileRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: LoadUserProfile = async () => {
    const request: HttpRequest<never> = { url: '/users/profile' }
    const response = await this.httpClient.get<ApiResponse>(request)
    const user: UserProfile = {
      userId: response.user.id,
      email: response.user.email,
      firstName: response.user.firstName,
      lastName: response.user.lastName,
      displayName: response.user.displayName,
      phone: response.user.phone,
      dateOfBirth: response.user.dateOfBirth,
      flywayRegion: response.user.flywayRegion,
      addressLine1: response.user.addressLine1,
      addressLine2: response.user.addressLine2,
      city: response.user.city,
      state: response.user.state,
      zipCode: response.user.zipCode,
      country: response.user.country,
      emergencyContact: response.user.emergencyContact,
      emergencyPhone: response.user.emergencyPhone,
      emergencyRelationship: response.user.emergencyRelationship,
      emergencyContact2: response.user.emergencyContact2,
      emergencyPhone2: response.user.emergencyPhone2,
      emergencyRelationship2: response.user.emergencyRelationship2,
      vehicleMake: response.user.vehicleMake,
      vehicleModel: response.user.vehicleModel,
      vehicleColor: response.user.vehicleColor,
      vehicleLicensePlate: response.user.vehicleLicensePlate,
      vehicleState: response.user.vehicleState,
      emailVerifiedAt: response.user.emailVerifiedAt,
      phoneVerifiedAt: response.user.phoneVerifiedAt,
      isStaff: response.user.isStaff,
      onboardingStep: response.user.onboardingStep,
      measurementSystem: response.user.measurementSystem,
    }
    const result: UserProfileResult = { exists: response.exists, user }
    return result
  }
}
